import { useMemo } from "react";
import {
  ArrowPathRoundedSquareIcon,
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
  useFetchData,
  useSearch,
  useToggle,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import { getRecurringPayment, toggleActive } from "./utils/api";
import MultiSearch from "./components/MultiSearch";
import { searchValues, excelHeaderCellsName } from "./utils/options";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  const links = [
    { name: "التبرعات", link: "/donations" },
    { name: "الإستقطاعات", link: "" },
  ];

  // Search state and update function
  const { search, updateSearch } = useSearch(searchValues);

  // Fetch data state and functions
  const { data, setData, isLoading, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getRecurringPayment,
      params: [search.values],
    });

  // Toggle active hook
  const { active } = useToggle(setData, toggleActive);

  // Append actions column
  const columns = useMemo(
    () => [
      ...tableColumns,
      {
        id: "actions",
        header: "خيارات",
        size: 120,
        cell: ({ row }) => (
          <TableActions row={row.original} toggleActive={active} />
        ),
      },
    ],
    [active],
  );

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="التبرعات / الاستقطاعات"
          title="الإستقطاعات"
          count={pg.rows}
          icon={ArrowPathRoundedSquareIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size })}
          />

          <DownloadExcel
            length={data?.length}
            search={search.values}
            fetch={getRecurringPayment}
            headerCellsName={excelHeaderCellsName}
          />

          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={fetchData}
          dataLength={data?.length}
          updateSearch={updateSearch}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
